import { SectionLabel } from "./WhatMakesSpecial";
import { RegisterLink } from "@/components/RegisterLink";

const slotGames = [
  { name: "JILI", img: "https://xt30sf.b-cdn.net/media/20af991e35f764c84cd5a.png" },
  { name: "MEGA888", img: "https://xt30sf.b-cdn.net/media/d9efa02e35f76d7dac0c1.png" },
  { name: "VPOWER", img: "https://xt30sf.b-cdn.net/media/be11472e35f763fa88bf3.png" },
  { name: "RICH88", img: "https://xt30sf.b-cdn.net/media/d63da43e35f76d3b74383.png" },
  { name: "918KAYA", img: "https://xt30sf.b-cdn.net/media/6510ab3e35f76f0c4502e.png" },
  { name: "IMPERIUM", img: "https://xt30sf.b-cdn.net/media/31f5514e35f76d409c985.png" },
];

const tableGames = [
  { title: "Baccarat", body: "The most popular table game at Rolex9. Bet on Player, Banker or Tie across multiple live and RNG baccarat variants — available 24/7 with real dealers." },
  { title: "Blackjack", body: "Classic and multi-hand blackjack tables with competitive rules. Perfect for strategy players looking for a low house edge and fast-paced action." },
  { title: "Roulette", body: "European and American roulette variants with full betting markets. Available in both RNG and live dealer formats for the complete casino experience." },
  { title: "Dragon Tiger", body: "A fast-paced Asian favourite — simply bet on Dragon or Tiger and watch the cards fall. One of the most popular live table games on Rolex9." },
];

const liveGames = [
  { title: "YeeBet", body: "A polished live dealer experience with smooth streaming and fast table switching. Enjoy popular live formats with a premium look and feel." },
  { title: "DreamGaming", body: "High-quality live casino tables with stable HD streams and a focus on core favourites like baccarat and roulette." },
  { title: "SexyBaccarat", body: "A signature live baccarat presentation built for entertainment and pace, featuring professional dealers and an immersive studio vibe." },
  { title: "Big Gaming", body: "A broad live dealer catalogue covering classic tables and trending formats, designed for fast play and reliable performance." },
];

const fishingGames = [
  { title: "Jackpot Fishing (JILI)", body: "Classic JILI fishing action with jackpot targets, fast-paced shooting, and satisfying hit feedback for quick sessions." },
  { title: "Ocean King (JILI)", body: "A fan-favourite ocean-themed fishing arcade with boss fish, weapon upgrades, and high-intensity moments built for big multipliers." },
  { title: "Happy Fishing (JILI)", body: "Bright, easy-to-play fishing gameplay with smooth controls and steady action, ideal for casual to regular fishing players." },
  { title: "Circus Jackpot (JILI)", body: "A colourful circus-style fishing variant featuring jackpot-focused objectives, special waves, and rewarding bonus moments." },
];

function SubLabel({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <div className="flex items-center gap-2 mb-5">
      <div className="h-px w-6" style={{ background: "linear-gradient(90deg, #c9a84c, transparent)" }}></div>
      <span className="text-[#c9a84c]/60 text-xs tracking-widest uppercase" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{children}</span>
    </div>
  );
}

export default function GamesSection() {
  return (
    <section id="games" className="max-w-5xl mx-auto px-6 py-12">
      <SectionLabel>Games</SectionLabel>
      <p className="text-white/40 text-sm leading-relaxed mb-10 max-w-2xl">
        Rolex9 hosts thousands of games across slots, live casino, fishing, table games and sports betting — powered by JILI, BNG, VPOWER, MEGA888, PUSSY888, 918KAYA, IMPERIUM, RICHGAMING, RICH88, PLAYSON, UUSLOTS, MARIOCLUB, CQ9 GAMING, ACE333, XE88, and many more top-tier providers.
      </p>

      <SubLabel>Slot Games</SubLabel>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-12">
        {slotGames.map((game) => (
          <div
            key={game.name}
            className="relative group rounded-2xl overflow-hidden cursor-pointer animate-border-glow"
            style={{ border: "1px solid rgba(255,255,255,0.06)" }}
          >
            <div className="w-full aspect-[320/407]">
              <img
                src={game.img}
                alt={game.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-3"
              style={{ background: "linear-gradient(180deg, rgba(3,7,33,0.85) 0%, rgba(10,5,40,0.9) 100%)" }}
            >
              <p className="text-white/90 font-semibold text-sm text-center px-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                {game.name}
              </p>
              <RegisterLink section="games" label={`Play Now - ${game.name}`} className="btn-glow px-6 py-2 rounded-xl text-xs text-center">Play Now</RegisterLink>
              <span className="text-white/30 text-xs tracking-widest uppercase">Play for Fun</span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-16 opacity-80"
              style={{ background: "linear-gradient(0deg, rgba(3,7,33,0.9), transparent)" }}
            ></div>
            <p className="absolute bottom-3 left-0 right-0 text-center text-white/60 text-xs group-hover:opacity-0 transition-opacity px-2 truncate">
              {game.name}
            </p>
          </div>
        ))}
      </div>

      <SubLabel>Live Dealer Casino</SubLabel>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
        {liveGames.map((g) => (
          <div key={g.title} className="glass-card-gold rounded-xl p-5">
            <p className="text-white/70 font-semibold text-sm mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{g.title}</p>
            <p className="text-white/30 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>

      <SubLabel>Table Games</SubLabel>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
        {tableGames.map((g) => (
          <div key={g.title} className="glass-card rounded-xl p-5">
            <p className="text-white/70 font-semibold text-sm mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{g.title}</p>
            <p className="text-white/30 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>

      <SubLabel>Fishing Games</SubLabel>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {fishingGames.map((g) => (
          <div key={g.title} className="glass-card rounded-xl p-5">
            <p className="text-white/70 font-semibold text-sm mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{g.title}</p>
            <p className="text-white/30 text-xs leading-relaxed">{g.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
